import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/pages/Home";
import Integrations from "./components/pages/Integrations";
import UserManager from "./components/settings/tabs/organizations/UserManager";
import AuthComponent from "./components/auth/AuthComponent";
import Layout from "./components/layout/Layout";
import MobileMessage from "./components/messages/MobileMessage";
import ProtectedRoute from "../src/utils/ProtectedRoute";
import useScreenSize from "./hooks/UseScreenSize";
import PasswordComponent from "./components/auth/PasswordResetComponent";
import VerifyEmail from "./components/auth/VerifyEmail";
import SubscriptionTierSelection from "./components/settings/tabs/SubscriptionTierSelection";
import Settings from "./components/settings/Settings";
import APILandingPage from "./components/api/APILandingPage";
import Unknown from "./components/api/Unknown";
import Terms from "./components/common/Terms";
import AcceptInvitation from "./components/auth/AcceptInvitation";
import HubSpotAgentPage from "./components/hubspot/HubSpotAgentPage";
import HubSpotSuccess from "./components/hubspot/HubSpotSuccess";
import HubSpotError from "./components/hubspot/HubSpotError";
import HubSpotDisplayPage from "./components/hubspot/HubSpotDisplayPage";
import HubSpotDocumentation from "./components/hubspot/HubSpotDocumentation";
import EmailHygienePage from "./components/emailhygiene/EmailHygienePage";
import AsanaLandingPage from "./components/asana/AsanaLandingPage";
import RevopsAgentLandingPage from "./components/revopsAgent/RevopsAgentLandingPage";
import SlackSuccess from "./components/slack/SlackSuccess";
import SlackError from "./components/slack/SlackError";
import AsanaSuccess from "./components/asana/AsanaSuccess";
import AsanaError from "./components/asana/AsanaError";
import StripeSuccess from "./components/stripe/StripeSuccess";
import StripeError from "./components/stripe/StripeError";
import ContractIntelligenceSetup from "./components/contractIntelligence/ContractIntelligenceSetup";
import FieldMapping from "./components/pages/FieldMapping";
import Customers from "./components/pages/Customers";
import Contracts from "./components/pages/Contracts";
import { usePageTitle } from "./hooks/usePageTitle";

// Staging trigger
const AppRoutes: React.FC = () => {
  const isMobile = useScreenSize();
  usePageTitle();

  if (isMobile) {
    return <MobileMessage />;
  }

  return (
    <Routes>
      <Route path="/auth" element={<AuthComponent />} />
      {/* <Route path="/landing-page" element={<LandingPage />} /> */}
      <Route path="/reset-password" element={<PasswordComponent />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/accept-invitation" element={<AcceptInvitation />} />
      <Route path="/api/landing-page" element={<APILandingPage />} />
      <Route path="/api/unknown" element={<Unknown />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/hubspot/documentation" element={<HubSpotDocumentation />} />

      <Route element={<ProtectedRoute />}>
        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/subscription-tier-selection"
          element={
            <Layout>
              <SubscriptionTierSelection />
            </Layout>
          }
        />

        <Route
          path="/asana-agent/landing-page"
          element={
            <Layout>
              <AsanaLandingPage />
            </Layout>
          }
        />
        <Route
          path="/revops-agent/landing-page"
          element={
            <Layout>
              <RevopsAgentLandingPage />
            </Layout>
          }
        />
        <Route
          path="/email-hygiene"
          element={
            <Layout>
              <EmailHygienePage />
            </Layout>
          }
        />

        <Route
          path="/integrations"
          element={
            <Layout>
              <Integrations />
            </Layout>
          }
        />
        <Route
          path="/field-mapping"
          element={
            <Layout>
              <FieldMapping />
            </Layout>
          }
        />
        <Route
          path="/customers"
          element={
            <Layout>
              <Customers />
            </Layout>
          }
        />
        <Route
          path="/contracts"
          element={
            <Layout>
              <Contracts />
            </Layout>
          }
        />
        <Route
          path="/hubspot/display"
          element={
            <Layout>
              <HubSpotDisplayPage />
            </Layout>
          }
        />
        <Route
          path="/hubspot/success"
          element={
            <Layout>
              <HubSpotSuccess />
            </Layout>
          }
        />
        <Route
          path="/hubspot/error"
          element={
            <Layout>
              <HubSpotError />
            </Layout>
          }
        />
        <Route
          path="/stripe/success"
          element={
            <Layout>
              <StripeSuccess />
            </Layout>
          }
        />
        <Route
          path="/stripe/error"
          element={
            <Layout>
              <StripeError />
            </Layout>
          }
        />
        <Route
          path="/user-management"
          element={
            <Layout>
              <UserManager />
            </Layout>
          }
        />
        <Route
          path="/hubspot-agent"
          element={
            <Layout>
              <HubSpotAgentPage />
            </Layout>
          }
        />
        <Route
          path="/settings"
          element={
            <Layout>
              <Settings />
            </Layout>
          }
        />
        <Route
          path="/slack/success"
          element={
            <Layout>
              <SlackSuccess />
            </Layout>
          }
        />
        <Route
          path="/slack/error"
          element={
            <Layout>
              <SlackError />
            </Layout>
          }
        />
        <Route
          path="/asana/success"
          element={
            <Layout>
              <AsanaSuccess />
            </Layout>
          }
        />
        <Route
          path="/asana/error"
          element={
            <Layout>
              <AsanaError />
            </Layout>
          }
        />
        <Route
          path="/contract-intelligence/setup"
          element={
            <Layout>
              <ContractIntelligenceSetup />
            </Layout>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/auth" replace />} />
    </Routes>
  );
};

export default AppRoutes;
